import React from "react";
import { makeStyles } from "@material-ui/styles";
import Form from "./components/Form";
import SimpleToolbar from "../../components/Toolbar/SimpleToolbar";
import { Card } from "react-bootstrap";
import clsx from "clsx";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

const DivisionCreate = (props) => {
  const { Link, pageLink, title, ...rest } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SimpleToolbar
        Link={Link}
        pageLink={"/contents/applications"}
        title={"Application"}
      />
      <div className={classes.content}>
        <Typography variant="h6" gutterBottom component="div">
          U CANT ADD AN APPLICATION FOR NOW
        </Typography>
      </div>
    </div>
  );
};

export default DivisionCreate;
